import { Badge } from '@/components/ui/badge'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'

// Cause → badge tint, so the decorative list reads as a spread of different causes.
const CAUSE_COLORS: Record<string, string> = {
  Health: 'bg-rose-100 text-rose-700',
  Environment: 'bg-emerald-100 text-emerald-700',
  'Arts & Culture': 'bg-violet-100 text-violet-700',
  Education: 'bg-sky-100 text-sky-700',
  'Hunger & Poverty': 'bg-amber-100 text-amber-700',
  Housing: 'bg-orange-100 text-orange-700',
}

const FALLBACK_COLOR = 'bg-primary/10 text-primary'

const PHILANTHROPISTS = [
  { name: 'Amara Mbeki', initials: 'AM', role: 'Board Member · New York, NY', causes: ['Education', 'Arts & Culture'] },
  { name: 'James Lin', initials: 'JL', role: 'Founder · San Francisco, CA', causes: ['Environment'] },
  { name: 'Sofia Reyes', initials: 'SR', role: 'Patron · Miami, FL', causes: ['Health', 'Hunger & Poverty'] },
  { name: 'David Okafor', initials: 'DO', role: 'Donor · Chicago, IL', causes: ['Housing'] },
]

// Static decorative mock of philanthropist profiles. Not interactive.
export default function PhilanthropistListPreview() {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/10 bg-card shadow-xs">
      <div className="border-b border-black/5 p-4">
        <p className="text-sm font-semibold tracking-tight">Philanthropists you&rsquo;d meet</p>
      </div>
      <ul className="divide-y divide-black/5">
        {PHILANTHROPISTS.map((p) => (
          <li key={p.name} className="flex items-center gap-3 px-4 py-3">
            <Avatar size="lg">
              <AvatarFallback className="bg-primary/10 text-sm font-semibold text-primary">
                {p.initials}
              </AvatarFallback>
            </Avatar>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium">{p.name}</p>
              <p className="truncate text-xs text-muted-foreground">{p.role}</p>
            </div>
            <div className="flex shrink-0 flex-wrap justify-end gap-1.5">
              {p.causes.map((cause) => (
                <Badge key={cause} className={CAUSE_COLORS[cause] ?? FALLBACK_COLOR}>
                  {cause}
                </Badge>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
